// @flow
import * as React from 'react';
import Box from 'sail/Box';
import Button from 'sail/Button';
import {defineMessages, useIntl} from 'react-intl';
import {useAnalytics} from 'docs/data';
import {api} from 'sail/Icon/Assets';
import {useStripeClui} from './helpers/react/provider';

import './style.scss';

export const StripeClui = (props: {}) => {
  const {trackAction} = useAnalytics();

  const {
    state: {openState},
    open,
    close,
  } = useStripeClui();

  const messages = defineMessages({
    showTerminal: {
      id: 'docsApp.showTerminal',
      description: 'Label for button to show the Stripe Shell.',
      defaultMessage: 'Try it online',
    },
    hideTerminal: {
      id: 'docsApp.HideTerminal',
      description: 'Label for button to hide the Stripe Shell.',
      defaultMessage: 'Close the Stripe Shell',
    },
  });

  const intl = useIntl();
  const showLabel = intl.formatMessage(messages.showTerminal);
  const hideLabel = intl.formatMessage(messages.hideTerminal);

  const handleOpen = () => {
    open();
    trackAction('stripe_shell_trial_open');
  };

  const handleClose = () => {
    close();
    trackAction('stripe_shell_trial_close');
  };

  return (
    <Box margin={{top: 24}}>
      <Button
        icon={api}
        color="blue"
        size="jumbo"
        onClick={openState === 'closed' ? handleOpen : handleClose}
        label={openState !== 'closed' ? hideLabel : showLabel}
      />
    </Box>
  );
};
